import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import Popup from '@jetbrains/ring-ui/components/popup/popup'
import Tag from '@jetbrains/ring-ui/components/tag/tag'

import styles from './RepositoryTag.css'

type Props = {
  repositories: string[]
  className?: string
}
function RepositoryTag({repositories, className}: Props) {
  if (repositories.length === 0) {
    return null
  }

  const renderAnchor = (
    <div className={styles.tagWrapper}>
      <Tag className={styles.tag} readOnly>{`+${repositories.length}`}</Tag>
    </div>
  )

  return (
    <Dropdown className={className} anchor={renderAnchor} hoverMode>
      <Popup className={styles.popup} offset={4}>
        <div className={styles.repositories}>
          {repositories.map((repository, index) => {
            const key = `${index}_${repository}`

            return <span key={key}>{repository}</span>
          })}
        </div>
      </Popup>
    </Dropdown>
  )
}

export default RepositoryTag
